import React from "react";

/**
 * The four summary cards (Cycle, PMS, Energy, Cravings). Clicking a card
 * switches the metric tab.
 *
 * @param {Object} props
 * @param {Array<Object>} props.cards - From core/model/cards.buildCards.
 * @param {string} props.active - Active metric id.
 * @param {(id: string) => void} props.onPick
 */
const SummaryCards = ({ cards, active, onPick }) => (
  <div className="grid grid-cols-4 gap-[12px]">
    {cards.map((c) => (
      <button
        key={c.id}
        type="button"
        onClick={() => onPick(c.id)}
        aria-pressed={c.id === active}
        className="flex flex-col gap-[10px] text-left cursor-pointer border border-[#ECECEC] rounded-[12px] px-[18px] py-[16px] text-[#1f1f1f] min-w-0 transition-shadow duration-200"
        style={{
          background: c.id === "periods" ? "#FDEFE7" : "#fff",
          boxShadow: c.id === active ? `0 0 0 2px ${c.color}` : "none",
        }}
      >
        <span className="flex items-center justify-between gap-[7px] w-full text-[13px] font-bold text-[#3a3a3a]">
          <span className="flex items-center gap-[7px]">
            <span className="w-[8px] h-[8px] rounded-[4px]" style={{ background: c.color }} />
            {c.name}
          </span>
          {c.hasTag && (
            <span
              className="text-[11px] font-semibold rounded-[10px] px-[8px] py-[2px]"
              style={{ background: c.tagBg, color: c.tagFg }}
            >
              {c.tag}
            </span>
          )}
        </span>
        <span className="flex items-baseline gap-[4px]">
          <span className="text-[30px] font-bold tracking-[-0.02em] leading-none">{c.value}</span>
          <span className="text-[13px] text-[#8a8a8a]">{c.unit}</span>
        </span>
        <span className="text-[13px] font-semibold" style={{ color: c.l3fg }}>
          {c.l3}
        </span>
        {c.l4 && <span className="text-[12px] text-[#6b6b6b]">{c.l4}</span>}
        {c.hasWarn && (
          <span className="self-start text-[11px] font-semibold text-[#8a4a1f] bg-[#FDEBDD] rounded-[10px] px-[8px] py-[2px]">
            {c.warn}
          </span>
        )}
      </button>
    ))}
  </div>
);

export default SummaryCards;
